var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"mb-6",attrs:{"src":require("@/assets/dsc_giris_logo.png"),"max-height":"350","min-height":"150"}}),_c('h2',{staticClass:"mb-3 google-sans-medium"},[_vm._v("ÖDEV PLATFORMU")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }